import { documentTypeUtils } from '@wix/santa-editor-utils';

export default {
  nestedBackgroundDesign: true,
  slidesContainer: true,
  focusable: true,
  canContain: false,
  canContainByStructure: false,
  allowLassoOnContainer: true,
  pinnable: false,
  supportedInCurrentDocument: () =>
    !documentTypeUtils.isCurrentDocumentTypeIsFluidDocument(),
};
